import React from "react";
import Image from "react-bootstrap/Image";
import styled from "styled-components";

const ComingSoon = ({ image }) => (
  <Wrapper>
    <Image
      src={image || "/illustrations/coming-soon.png"}
      className="d-block mx-auto mb-8"
      style={{ height: 120 }}
      fluid
    />

    <div className="text-center">
      <h2 className="mb-4">Coming soon</h2>
      <small className="text-gray">
        This feature is under construction. We work quickly, so check back soon.
      </small>
    </div>
  </Wrapper>
);

/**
 * styles
 */
const Wrapper = styled.div`
  padding: 8.5rem 1.5rem;
  max-width: 20.5rem;
  margin: 0 auto;
`;

export default ComingSoon;
